<header>
    <div class="header-row wrapper container-fluid p-0">
        <div class="row m-0">
            <div class="header_logo width20" *ngIf="showPartner">
                <div class="row nomargin solutionName">
                    <div placement="bottom" [ngbPopover]="solutionListTemplate" class="leftDropdown row ">
                        <div class="col-3 col-offset-1">
                            <a>
                                <img src="assets/images/risepoint-logo.png" alt="logo" width="50" height="45" />
                            </a>
                        </div>
                        <div class="col-9 solutionName">
                            <div class="solutionName solutionHeightFix" *ngIf="selectedSolution?.alias !== undefined">{{selectedSolution?.alias}}
                                <fa-icon [icon]="faAngleDown" aria-hidden="true" class="far-1x" style="vertical-align:text-bottom;color: #005d99;float:right"></fa-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #solutionListTemplate>
                    <ng-container *ngFor="let solution of solutionList">
                        <div class="dropdownText" [ngClass]="selectedSolution.id == solution.id ? 'hideDisplay' : ''" (click)="changeSolution(solution)" id="solution.idName" *ngIf="solution.perm">
                            {{solution.name}}
                            <img [src]="solution.imageSrc" alt="icon" />
                        </div>
                    </ng-container>

                </ng-template>
            </div>
            <div class="header_logo header_logoFull width20 nopadding removeLogo" *ngIf="!showPartner">
                <a>
                    <img src="assets/images/RISEPOINT_LOGO_GREEN_RGB.png" alt="logo" width="250" height="83" />
                </a>
            </div>
            <div class="header_menu width80">
                <div class="row m-0">
                    <div class="col-8" *ngIf="showPartner">
                        <ng-select [items]="universities" bindLabel="UniversityFullName" class="status-dropdown" [searchable]="true" [clearable]="false" [searchFn]="customSearchFn"  [(ngModel)]="selectedPartner" (change)="changePartner(selectedPartner)">
                        </ng-select>
                    </div>
                    <div class="col col-offset-3 iconsRight">
                        <a *ngIf="dataDictionaryUrl" [href]="dataDictionaryUrl" target="_blank" rel="noopener noreferrer" role="button" title="Dictionary">
                            <fa-icon [icon]="faBook" class="faiconstyle" aria-hidden="true" size="2x" style="vertical-align:text-bottom;"></fa-icon>
                        </a>
                        <a (click)="redirectToWorkflowDashboard('WorkflowDashboard')" [routerLink]="'WorkflowDashboard'" role="button" [hidden]="!(userPerms?.workflow)" title="Workflow Dashboard">
                            <fa-icon [icon]="faThList" class="faiconstyle" aria-hidden="true" size="2x" style="vertical-align:text-bottom;"></fa-icon>
                        </a>                        
                        <a (click)="redirectToDashboard(null)" role="button" title="Home">
                            <fa-icon [icon]="faHome" class="faiconstyle" aria-hidden="true" size="2x" style="vertical-align:text-bottom"></fa-icon>
                        </a>
                    </div>
                    <div class="col-2" id="logout">
                        <div class="row ">
                            <div class="col welcomeText">
                                Welcome
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button class="solutionName userSelectBox" placement="bottom" [ngbPopover]="logOutpopContent">
                    {{userName}}
                  </button>
                                <ng-template #logOutpopContent>
                                    <div class="logout" (click)="logout()">Logout</div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
